module.exports = __webpack_public_path__ + "static/media/Deep_Breathing_1.8.cb4df376.mp3";